/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Swal_MessageInputs */

const en_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your default browser will open to complete the checkout process.<br><br><strong>The application will close automatically.</strong><br><br>After completing your sign up, please reopen Closed Caption Creator.`)
};

const fr_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre navigateur par défaut s'ouvrira pour terminer le processus de paiement.<br><br><strong>L'application se fermera automatiquement.</strong><br><br>Après avoir terminé votre inscription, veuillez rouvrir Closed Caption Creator.`)
};

const de_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Standardbrowser wird sich öffnen, um den Bestellvorgang abzuschließen.<br><br><strong>Die Anwendung wird automatisch geschlossen.</strong><br><br>Bitte öffnen Sie Closed Caption Creator nach Abschluss Ihrer Registrierung erneut.`)
};

const it_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si aprirà il browser predefinito per completare la procedura di pagamento.<br><br><strong>L'applicazione si chiuderà automaticamente.</strong><br><br>Dopo aver completato la registrazione, riapri Closed Caption Creator.`)
};

const ru_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для завершения процесса оформления заказа откроется ваш браузер по умолчанию.<br><br><strong>Приложение закроется автоматически.</strong><br><br>После завершения регистрации, пожалуйста, снова откройте приложение «Создатель субтитров».`)
};

const es_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se abrirá su navegador predeterminado para completar el proceso de pago.<br><br><strong>La aplicación se cerrará automáticamente.</strong><br><br>Después de completar su registro, vuelva a abrir Closed Caption Creator.`)
};

const zh_cn2_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的默认浏览器将打开以完成结账流程。<br><br><strong>应用程序将自动关闭。</strong><br><br>完成注册后，请重新打开字幕创建器。</strong>`)
};

const ja_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックアウトのプロセスを完了するためにデフォルトのブラウザが開きます。<br><br><strong>アプリケーションは自動的に閉じます。</strong><br><br>サインアップを完了したら、Closed Caption Creator を再度開いてください。`)
};

const hi_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चेकआउट प्रक्रिया पूरी करने के लिए आपका डिफ़ॉल्ट ब्राउज़र खुल जाएगा।<br><br><strong>एप्लिकेशन अपने आप बंद हो जाएगा।</strong><br><br>साइन अप पूरा करने के बाद, कृपया क्लोज्ड कैप्शन क्रिएटर को दोबारा खोलें।`)
};

const pt_pt2_signup_swal_message = /** @type {(inputs: Signup_Swal_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu navegador padrão será aberto para concluir o processo de finalização da compra.<br><br><strong>O aplicativo será fechado automaticamente.</strong><br><br>Após concluir seu cadastro, abra novamente o Closed Caption Creator.`)
};

/**
* | output |
* | --- |
* | "Your default browser will open to complete the checkout process.<br><br><strong>The application will close automatically.</strong><br><br>After completing yo..." |
*
* @param {Signup_Swal_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_swal_message = /** @type {((inputs?: Signup_Swal_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Swal_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_swal_message(inputs)
	if (locale === "de") return de_signup_swal_message(inputs)
	if (locale === "it") return it_signup_swal_message(inputs)
	if (locale === "ru") return ru_signup_swal_message(inputs)
	if (locale === "es") return es_signup_swal_message(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_swal_message(inputs)
	if (locale === "ja") return ja_signup_swal_message(inputs)
	if (locale === "hi") return hi_signup_swal_message(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_swal_message(inputs)
	return en_signup_swal_message(inputs)
});